import { render, staticRenderFns } from "./AccountBalancesForAccountWidget.vue?vue&type=template&id=40511016&scoped=true&"
import script from "./AccountBalancesForAccountWidget.vue?vue&type=script&lang=js&"
export * from "./AccountBalancesForAccountWidget.vue?vue&type=script&lang=js&"
import style0 from "./AccountBalancesForAccountWidget.vue?vue&type=style&index=0&id=40511016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40511016",
  null
  
)

export default component.exports